import { createContext, PropsWithChildren, useContext } from 'react';

export interface RootContextType {
  retryVerifySession(): void;
  setSession(session: string): Promise<void>;
  isValidSession: boolean;
  removeLocalSession(): Promise<void>;
}

const RootContext = createContext<RootContextType>(null!);

export interface RootContextProviderProps {
  retryVerifySession(): void;
  setSession(session: string): Promise<void>;
  isValidSession: boolean;
  removeLocalSession(): Promise<void>;
}

export const RootProvider = (
  props: PropsWithChildren<RootContextProviderProps>,
) => {
  return (
    <RootContext.Provider
      value={{
        retryVerifySession: props.retryVerifySession,
        setSession: props.setSession,
        isValidSession: props.isValidSession,
        removeLocalSession: props.removeLocalSession,
      }}
    >
      {props.children}
    </RootContext.Provider>
  );
};

export const useRoot = () => {
  return useContext(RootContext);
};
